export const languages = [
  {label: 'English', value: 'en', icon: 'en'},
  {label: 'Deutsch', value: 'de', icon: 'de'}
]
